"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _hooks = require("@nicbase/hooks");

var _nicbaseForms = require("nicbase-forms");

var _nicbaseIcons = require("nicbase-icons");

var _nicbaseReducers = require("nicbase-reducers");

var _nicbaseSecurity = require("nicbase-security");

var _nicbaseTranslation = require("nicbase-translation");

var _informationStepModule = _interopRequireDefault(require("./information-step.module.scss"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var Information = function Information(_ref) {
  var _tour$additionalData, _tour$additionalData$, _tour$additionalData2, _tour$additionalData3, _tour$additionalData4, _tour$additionalData5, _tour$additionalData6, _tour$additionalData7, _tour$additionalData8, _tour$additionalData9;

  var tour = _ref.tour,
      errors = _ref.errors,
      touched = _ref.touched,
      onUpdate = _ref.onUpdate;
  var intl = (0, _nicbaseTranslation.useIntl)();

  var _usePortal = (0, _nicbaseReducers.usePortal)(),
      portalId = _usePortal.id;

  var name = tour.name,
      externalId = tour.externalId,
      _tour$projects = tour.projects,
      tourProjects = _tour$projects === void 0 ? [] : _tour$projects;

  var _usePortalSystemExcha = (0, _hooks.usePortalSystemExchangeProjects)(portalId),
      _usePortalSystemExcha2 = _usePortalSystemExcha.data,
      projects = _usePortalSystemExcha2 === void 0 ? [] : _usePortalSystemExcha2,
      isLoadingSystemExchangeProjects = _usePortalSystemExcha.isLoading;

  var systemExchangeProjectSource = (0, _react.useMemo)(function () {
    return _toConsumableArray(projects).sort(function (a, b) {
      return a.projectName > b.projectName ? 1 : -1;
    }).map(function (project) {
      return {
        label: project.projectName,
        value: project.id
      };
    });
  }, [projects]);
  var formDefinition = {
    railwayUndertaking: (_tour$additionalData = tour.additionalData) === null || _tour$additionalData === void 0 ? void 0 : (_tour$additionalData$ = _tour$additionalData.railInfo) === null || _tour$additionalData$ === void 0 ? void 0 : _tour$additionalData$.railwayUndertaking,
    senderName: (_tour$additionalData2 = tour.additionalData) === null || _tour$additionalData2 === void 0 ? void 0 : (_tour$additionalData3 = _tour$additionalData2.railInfo) === null || _tour$additionalData3 === void 0 ? void 0 : _tour$additionalData3.senderName,
    receiverName: (_tour$additionalData4 = tour.additionalData) === null || _tour$additionalData4 === void 0 ? void 0 : (_tour$additionalData5 = _tour$additionalData4.railInfo) === null || _tour$additionalData5 === void 0 ? void 0 : _tour$additionalData5.receiverName,
    customerName: (_tour$additionalData6 = tour.additionalData) === null || _tour$additionalData6 === void 0 ? void 0 : (_tour$additionalData7 = _tour$additionalData6.railInfo) === null || _tour$additionalData7 === void 0 ? void 0 : _tour$additionalData7.customerName,
    tariff: (_tour$additionalData8 = tour.additionalData) === null || _tour$additionalData8 === void 0 ? void 0 : (_tour$additionalData9 = _tour$additionalData8.railInfo) === null || _tour$additionalData9 === void 0 ? void 0 : _tour$additionalData9.tariff
  };

  var onProjectChange = function onProjectChange(id, index) {
    if (!tourProjects.some(function (tourProject) {
      return tourProject.id === id;
    })) {
      var _projects$find;

      var _ref2 = (_projects$find = projects.find(function (currentProject) {
        return currentProject.id === id;
      })) !== null && _projects$find !== void 0 ? _projects$find : {},
          tourProperties = _ref2.tourProperties,
          projectType = _ref2.projectType;

      var newProject = _objectSpread(_objectSpread({}, tourProjects[index]), {
        id: id,
        type: projectType,
        tourProperties: Object.fromEntries(Object.entries(tourProperties !== null && tourProperties !== void 0 ? tourProperties : {}).map(function (_ref3) {
          var _ref4 = _slicedToArray(_ref3, 1),
              key = _ref4[0];

          return [key, ''];
        }))
      });

      onUpdate({
        projects: [].concat(_toConsumableArray(tourProjects.slice(0, index)), [newProject], _toConsumableArray(tourProjects.slice(index + 1)))
      });
    }
  };

  var onInputChange = function onInputChange(index, key, value) {
    var changedProject = _objectSpread(_objectSpread({}, tourProjects[index]), {}, {
      tourProperties: _objectSpread(_objectSpread({}, tourProjects[index].tourProperties), {}, _defineProperty({}, key, value))
    });

    onUpdate({
      projects: [].concat(_toConsumableArray(tourProjects.slice(0, index)), [changedProject], _toConsumableArray(tourProjects.slice(index + 1)))
    });
  };

  var onAddClicked = function onAddClicked() {
    onUpdate({
      projects: [].concat(_toConsumableArray(tourProjects), [{
        id: null,
        tourProperties: {}
      }])
    });
  };

  var onRemoveClicked = function onRemoveClicked(index) {
    onUpdate({
      projects: [].concat(_toConsumableArray(tourProjects.slice(0, index)), _toConsumableArray(tourProjects.slice(index + 1)))
    });
  };

  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "w-128 px-2"
  }, isLoadingSystemExchangeProjects ? /*#__PURE__*/_react["default"].createElement(_nicbaseIcons.NicbaseSpinnerComponent, null) : /*#__PURE__*/_react["default"].createElement("div", {
    className: "mx-12"
  }, /*#__PURE__*/_react["default"].createElement(_nicbaseForms.Input, {
    className: true,
    value: name,
    onChange: function onChange(newValue) {
      return onUpdate({
        name: newValue
      });
    },
    type: "text",
    error: touched.name && errors.name ? /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
      id: "widgets.tourBoard.rail.createTour.name.error",
      tagName: "span"
    }) : null,
    label: /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
      id: "widgets.tourBoard.rail.createTour.name",
      tagName: "span"
    }, function (message) {
      return "".concat(message, "*");
    }),
    maxLength: 64
  }), /*#__PURE__*/_react["default"].createElement(_nicbaseForms.Input, {
    value: externalId,
    onChange: function onChange(newValue) {
      return onUpdate({
        externalId: newValue
      });
    },
    type: "text",
    label: /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
      id: "widgets.tourBoard.rail.createTour.externalId",
      tagName: "span"
    }),
    maxLength: 64
  }), Object.entries(formDefinition).map(function (_ref5) {
    var _ref6 = _slicedToArray(_ref5, 2),
        key = _ref6[0],
        value = _ref6[1];

    return /*#__PURE__*/_react["default"].createElement(_nicbaseForms.Input, {
      key: key,
      value: value,
      onChange: function onChange(newValue) {
        var _tour$additionalData10;

        return onUpdate({
          additionalData: _objectSpread(_objectSpread({}, tour.additionalData), {}, {
            railInfo: _objectSpread(_objectSpread({}, (_tour$additionalData10 = tour.additionalData) === null || _tour$additionalData10 === void 0 ? void 0 : _tour$additionalData10.railInfo), {}, _defineProperty({}, key, newValue))
          })
        });
      },
      type: "text",
      label: /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
        id: "widgets.tourBoard.rail.createTour.".concat(key),
        tagName: "span"
      }),
      maxLength: 64
    });
  }), projects.length > 0 && /*#__PURE__*/_react["default"].createElement("div", {
    className: "mt-6"
  }, tourProjects.map(function (project, index) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      key: index,
      className: _informationStepModule["default"].container
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "flex items-center"
    }, /*#__PURE__*/_react["default"].createElement(_nicbaseForms.Dropdown, {
      label: /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
        id: "widgets.tourBoard.project"
      }),
      onChange: function onChange(id) {
        return onProjectChange(id, index);
      },
      source: systemExchangeProjectSource,
      value: project.id,
      className: "w-96"
    }), /*#__PURE__*/_react["default"].createElement("button", {
      className: _informationStepModule["default"].removeProject,
      title: intl.formatMessage({
        id: 'widgets.tourBoard.deleteProject'
      }),
      onClick: function onClick() {
        return onRemoveClicked(index);
      }
    }, /*#__PURE__*/_react["default"].createElement(_nicbaseIcons.Delete, {
      className: "fill-primary"
    }))), project.tourProperties ? Object.entries(project.tourProperties).map(function (_ref7) {
      var _ref8 = _slicedToArray(_ref7, 2),
          key = _ref8[0],
          value = _ref8[1];

      return /*#__PURE__*/_react["default"].createElement(_nicbaseForms.Input, {
        value: value,
        label: key,
        onChange: function onChange(inputValue) {
          return onInputChange(index, key, inputValue);
        }
      });
    }) : null);
  }), /*#__PURE__*/_react["default"].createElement("button", {
    type: "button",
    tabIndex: 0,
    className: "add-text-primary inline-flex items-center cursor-pointer font-bold focus:outline-none",
    onClick: onAddClicked
  }, /*#__PURE__*/_react["default"].createElement(_nicbaseIcons.Plus, {
    className: "inline-block fill-primary mr-2 cursor-pointer"
  }), /*#__PURE__*/_react["default"].createElement("span", null, /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
    id: "widgets.tourBoard.addProject"
  }))))));
};

Information.propTypes = {
  tour: _propTypes["default"].shape({
    name: _propTypes["default"].string,
    externalId: _propTypes["default"].string,
    additionalData: _propTypes["default"].shape({
      railInfo: _propTypes["default"].shape({
        railwayUndertaking: _propTypes["default"].string,
        senderName: _propTypes["default"].string,
        receiverName: _propTypes["default"].string,
        customerName: _propTypes["default"].string,
        tariff: _propTypes["default"].string
      })
    }),
    projects: _propTypes["default"].arrayOf(_propTypes["default"].shape({
      id: _propTypes["default"].number,
      tourProperties: _propTypes["default"].shape({})
    }))
  }),
  errors: _propTypes["default"].shape({
    name: _propTypes["default"].string
  }),
  touched: _propTypes["default"].shape(),
  onUpdate: _propTypes["default"].func
};

var noop = function noop() {};

Information.defaultProps = {
  tour: {},
  errors: {},
  touched: {},
  onUpdate: noop
};

var _default = (0, _nicbaseSecurity.authorize)('PORTAL')(['module.tour.rail'])(Information);

exports["default"] = _default;